export default "__VITE_ASSET__e276ea39__$_?nuxt_component=async__"